export enum CalculationListTypeEnum {
  All = '',
  Active = 'active',
  Incomplete = 'incomplete',
  Migrated = 'migrated',
}
